import { Reducer } from 'redux';
import { SolicitacoesRetornoItensNotaState, SolicitacoesRetornoItensNotaTypes } from './types';

const INITIAL_STATE = {
  data: [],
  loading: false,
  error: false,
  filter: undefined,
  sorter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<SolicitacoesRetornoItensNotaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case SolicitacoesRetornoItensNotaTypes.ITENS_NOTA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
